import React from 'react';
import { Transition, Icon } from 'semantic-ui-react';
import BotaoEditar from '../../layouts/BotaoEditar';

const iniciais = nome =>
  (nome || '?').split(/\s+/).filter(Boolean).slice(0, 2).map(p => p[0].toUpperCase()).join('');

const soNumeros = valor => Array.from((valor || '').trim()).filter(n => !isNaN(parseInt(n, 10))).join('');

const formatarDocumento = (doc, tipo) => {
  const n = soNumeros(doc);
  if (n.length === 11) return n.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  if (n.length === 14) return n.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  return doc || (tipo ? '' : 'Não informado');
};

// Linha de proprietário (lista): todos os dados visíveis sem abrir o cadastro.
const Responsavel = ({ responsavel, condominio, unidades = [], animation }) => (
  <Transition duration={!isNaN(animation) ? animation : 500} animation="fade up" transitionOnMount={true}>
    <article className="va-prop-linha">
      <span className="va-prop-avatar">{iniciais(responsavel.nome)}</span>

      <div className="va-prop-principal">
        <h3>
          {responsavel.nome}
          {responsavel.tipoDocumento && <span className="va-prop-doc">{responsavel.tipoDocumento}</span>}
        </h3>
        <ul className="va-prop-dados">
          <li title="Documento"><Icon name="id card outline" />{formatarDocumento(responsavel.documento, responsavel.tipoDocumento)}</li>
          <li title="Celular">
            <Icon name="phone" />
            {responsavel.celular
              ? <a href={`tel:${soNumeros(responsavel.celular)}`}>{responsavel.celular}</a>
              : <span className="va-prop-vazio">Não informado</span>}
          </li>
          <li title="E-mail">
            <Icon name="mail outline" />
            {responsavel.email
              ? <a href={`mailto:${responsavel.email}`}>{responsavel.email}</a>
              : <span className="va-prop-vazio">Não informado</span>}
          </li>
        </ul>
      </div>

      <div className="va-prop-unidades-linha">
        <small>{unidades.length === 0 ? 'Sem unidade' : `${unidades.length} unidade${unidades.length !== 1 ? 's' : ''}`}</small>
        <div>
          {unidades.map(u => (
            <span key={u._id} className={`va-prop-unidade ${u.bloqueadoVotacao ? 'bloqueada' : ''}`} title={u.bloqueadoVotacao ? 'Votação bloqueada' : 'Habilitada'}>
              {u.bloqueadoVotacao && <Icon name="ban" />}
              {[u.bloco, u.numero].filter(Boolean).join(' · ')}
            </span>
          ))}
        </div>
      </div>

      <div className="va-prop-acao">
        <BotaoEditar
          to={`/condominios/${condominio._id}/responsaveis/editar/${responsavel._id}`}
          dica="Editar proprietário"
          rotulo={`Editar ${responsavel.nome}`}
        />
      </div>
    </article>
  </Transition>
);

export default Responsavel;
